import React from 'react'
import { PALETTE } from '../../styles/constants'

function ChevronDownIconCollapsible({ color = PALETTE.gray80 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <g clipPath="url(#clip0_2209_3411)">
        <path d="M16 22.0001L6 12.0001L7.4 10.6001L16 19.2001L24.6 10.6001L26 12.0001L16 22.0001Z" fill={color}/>
      </g>
      <defs>
        <clipPath id="clip0_2209_3411">
          <rect width="32" height="32" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default ChevronDownIconCollapsible
